import { View } from './view'

export const ProductsLandPages = View
